module.exports = __webpack_public_path__ + "img/award2022.d332da66.svg";